"use strict";
/*!
 * Copyright 2018 acrazing <joking.young@gmail.com>. All rights reserved.
 * @since 2018-12-15 15:35:02
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.options = {
    /**
     * is ssr or not, this only need to be set as true at server side.
     */
    ssr: false,
};
/**
 * update the configuration
 * @param input
 */
function config(input) {
    tslib_1.__assign(exports.options, input);
}
exports.config = config;
//# sourceMappingURL=config.js.map